import { getErrorMessages } from 'common/utils';
import { IntlShape } from 'react-intl';

export const validateEmail = (value: string, formatMessage: IntlShape['formatMessage']) => {
  const { fieldCannotBeEmpty, emailNotValid } = getErrorMessages(formatMessage);
  return {
    ...(!value && { email: fieldCannotBeEmpty }),
    ...(!/(^|\s)[-a-z0-9_.]+@([-a-z0-9]+.)+[a-z]{2,6}(\s|$)/.test(value) && { email: emailNotValid }),
  };
};
